import { CreateHatchCoverMoveCommand, HatchCoverMovesApi, UpdateHatchCoverMoveCommand } from '@operations/app/api'
import { createApiClient } from '@operations/app/http-client'

class HatchCoverMoveService {
  httpClient = createApiClient(HatchCoverMovesApi)

  getHatchCoverMovesByVesselVisitId = async (vesselVisitId: number) => {
    const { data } = await this.httpClient.getHatchCoverMovesByVesselVisitId(vesselVisitId)
    return data
  }

  create = async (cmd: CreateHatchCoverMoveCommand) => {
    await this.httpClient.create(cmd)
  }

  update = async (cmd: UpdateHatchCoverMoveCommand) => {
    await this.httpClient.update(cmd)
  }

  delete = async (id: number) => {
    await this.httpClient._delete(id)
  }
}

const hatchCoverMoveService = new HatchCoverMoveService()

export default hatchCoverMoveService
